/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {Favorite} from "../model/favorite";

@Injectable({
    providedIn: "root",
})
export class SimFavoriteService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public getScenarioRecordingFavorite(scenarioRecordingId: string) {
        return super.get<Favorite>(`/api/Favorite/GetScenarioRecordingFavorite`, {scenarioRecordingId: scenarioRecordingId});
    }

    public toggleScenarioRecordingFavorite(scenarioRecordingId: string) {
        return super.get<boolean>(`/api/Favorite/ToggleScenarioRecordingFavorite`, {scenarioRecordingId: scenarioRecordingId});
    }
}